import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=e79a146a&scoped=true&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts&"
import style0 from "./reset-password-modal.scss?vue&type=style&index=0&id=e79a146a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79a146a",
  null
  
)

export default component.exports